/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
import React, { Component } from "react"
import Hls from "hls.js"
import { Button, Icon, Row, Label, getProperty } from "trux"

import "./PreviewVideo.css"

const apiEndpoint = process.env.REACT_APP_API

export default class PreviewVideo extends Component {
    constructor(props) {
        super(props)

        this.state = {
            utc: 0,
            time: 1,
            x: 500,
            y: 500,
            scale: 1,
            loading: false,
        }

        if (this.props.spotlight) {
            this.state = Object.assign(this.state, this.props.spotlight)
        }

        this.videoReady = this.videoReady.bind(this)
    }

    componentDidMount() {
        if (this.props.clip) {
            this.loadVideo()
        }
    }

    componentDidUpdate() {
        if (this.props.clip) {
            this.loadVideo()
        }
    }

    loadVideo() {
        var video = document.getElementById("preview-video")
        video.volume = 0
        let clip = this.props.clip
        let teamName = this.props.teamName
        let gameId = this.props.gameId

        const hlsUrl =
            apiEndpoint +
            "/teams/" +
            teamName +
            "/games/" +
            teamName +
            "-" +
            gameId +
            "/" +
            clip.dynamic.hls
        let nativeHls =
            video.canPlayType &&
            !!video.canPlayType("application/vnd.apple.mpegURL")

        // Make sure we just load once
        if (this.loadingVideoUrl === hlsUrl) {
            return
        }
        this.loadingVideoUrl = hlsUrl

        if (nativeHls) {
            video.setAttribute("src", hlsUrl)
            video.load()
            video.addEventListener("canplay", this.videoReady)
        } else if (Hls.isSupported()) {
            //this.cleanHls()
            this.hls = new Hls()
            this.hls.loadSource(hlsUrl)
            this.hls.attachMedia(video)
            this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
                this.videoReady()
            })
        }
    }

    videoReady() {
        let video = document.getElementById("preview-video")
        video.removeEventListener("canplay", this.videoReady)

        video.currentTime = 0
        video.loop = true
        try {
            video.play()
        } catch (e) {
            // nothing to do
        }
        this.setState({ loaded: true })
    }

    onPlay() {
        let video = document.getElementById("preview-video")
        video.currentTime = 0
        video.loop = true
        try {
            video.play()
        } catch (e) {
            // nothing to do
        }
    }

    render() {
        let video = document.getElementById("preview-video")
        let overlayStyles = {}
        if (video) {
            let vw = video.offsetWidth
            let vh = video.offsetHeight

            let xpos = (this.state.x / 1000) * vw
            let ypos = (this.state.y / 1000) * vh

            let bw = this.state.scale * 2000
            let bh = this.state.scale * 2000

            let bx = bw / -2 + xpos
            let by = bh / -2 + ypos

            overlayStyles["backgroundSize"] = `${bw}px ${bh}px`
            overlayStyles["backgroundPosition"] = `${bx}px ${by}px`

            console.log(
                "EditSpotlight x",
                this.state.x,
                "y",
                this.state.y,
                "vw",
                vw,
                "vh",
                vh
            )
        }

        let clipDuration = getProperty("clip.dynamic.duration", this.props, 30)
        let fw = (this.state.time / clipDuration) * 100

        console.log("Slider style", fw, this.state.time, clipDuration)
        overlayStyles.display = this.props.disabled ? "none" : "block"

        return (
            <div className="PreviewVideoContainer">
                <div className="PreviewVideo center Column">
                    <video
                        id="preview-video"
                        playsInline
                        style={{ margin: "16px auto 8px", width: "300px" }}
                    />
                    <Button
                        trkAction="Preview Play Pressed"
                        onClick={(e) => {
                            this.onPlay()
                        }}
                        content="Play from start"
                        small
                        marginBottom="4"
                    />
                    <Row marginLeft="4" marginRight="4" marginBottom="2">
                        <Label
                            span="10"
                            left
                            marginBottom="4"
                            content={
                                <>
                                    <strong>Organize:</strong> Add moments from
                                    any match. Showcase moments with tags to add
                                    context.
                                </>
                            }
                        />
                    </Row>
                    <Row marginLeft="4" marginRight="4" marginBottom="2">
                        <Label
                            span="10"
                            left
                            marginBottom="4"
                            content={
                                <>
                                    <strong>Share:</strong> The easiest way to
                                    give anyone access to the moments you care
                                    about.
                                </>
                            }
                        />
                    </Row>
                    <Row marginLeft="4" marginRight="4" marginBottom="2">
                        <Label
                            span="10"
                            left
                            marginBottom="4"
                            content={
                                <>
                                    <strong>Discover:</strong> Dive deep into a
                                    moment with radar, jumping to full games,
                                    stats and more.
                                </>
                            }
                        />
                    </Row>
                </div>
            </div>
        )
    }
}
